import React from 'react';
import PageIdLink from './PageIdLink';
import Group from './script/Group';

const Script = ({scripts, items, parameters, extraFields}) => (
    <>
        {scripts.map((script, index) => (
            <div key={index} className="row align-items-center alert alert-warning">
                <div className="col-10">
                    <Group expressions={script.expression} items={items} parameters={parameters} extraFields={extraFields} />
                </div>
                <div className="col-2 text-right">
                    <PageIdLink id={script.jumpTo} />
                </div>
            </div>
        ))}
    </>
);

export default Script;
